const FA_DIGITS = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹']

/** Convert latin digits in a string/number to Persian digits. */
export function fa(input: string | number): string {
  return String(input).replace(/[0-9]/g, (d) => FA_DIGITS[Number(d)])
}

/** Format a rial amount with thousands separators + Persian digits. */
export function rial(amount: number): string {
  return fa(amount.toLocaleString('en-US')) + ' تومان'
}

/** Format a foreign-currency amount. */
// export function fx(amount: number, currency: "USD" | "EUR"): string {
//   const symbol = currency === "USD" ? "$" : "€"
//   return symbol + fa(amount.toLocaleString("en-US"))
// }
export function fx(amount: number, currency: 'USD' | 'EUR'): string {
  const symbol = currency === 'USD' ? '$' : '€'

  return (
    symbol +
    fa(
      amount.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    )
  )
}
